const isThemeDefault = () => {
	// Check for the cookie
	const hasCookie = document.cookie.includes("theme--default=true");

	return hasCookie;
};

export default isThemeDefault;